import type {
	PortalSubmitIssueRequestDto,
	PortalSubmitIssueResponseDto,
} from '@supply-mover-2-0/shared';
import { portalFetch } from '../lib/apiClient';

/**
 * Submit a support issue from the storefront (PD-13705). Login required —
 * the API links the issue to the customer's active client.
 */
export async function submitPortalIssue(
	token: string,
	payload: PortalSubmitIssueRequestDto,
): Promise<PortalSubmitIssueResponseDto> {
	return portalFetch<PortalSubmitIssueResponseDto>('/issues', token, {
		method: 'POST',
		body: JSON.stringify(payload),
	});
}
